import { render, staticRenderFns } from "./agenda-approvals.vue?vue&type=template&id=72d98ff8&scoped=true&"
import script from "./agenda-approvals.vue?vue&type=script&lang=js&"
export * from "./agenda-approvals.vue?vue&type=script&lang=js&"
import style0 from "./agenda-approvals.vue?vue&type=style&index=0&id=72d98ff8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d98ff8",
  null
  
)

export default component.exports